/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import IDocumentoDetalleCompuesto from '../smartStock/documentosDetalle/entidades/documentoDetalleCompuesto';
import { negocio } from '../conexiones/index';
import IDocumentoConDetalleCompuesto from '../../modelos/smartStock/documentosDetalle/entidades/documentoConDetalleCompuesto';
import IDocumentoDetalle from 'Infotrack@Modelos/smartStock/documentosDetalle/entidades/documentoDetalle';

export default class ModeloDocumentoDetalle {
    public ConsultarDocumentoDetalle(documentoDetalleCompuesto: Partial<IDocumentoDetalleCompuesto>) {
        return manejadorRest<IRespuesta<IDocumentoConDetalleCompuesto>>(
            () => negocio.post('DocumentosDetalles/ConsultarDocumentosDetalleAgrupado', documentoDetalleCompuesto),
            true
        );
    }
    public eliminarDocumentosDetalles(documentoConDetalle: IDocumentoDetalle) {
        return manejadorRest<IRespuesta<IDocumentoDetalle>>(
            () => negocio.delete('DocumentosDetalles/EliminarDocumentosDetalles', documentoConDetalle),
            true
        );
    }
}
